import { createSlice } from "@reduxjs/toolkit";

const initialState = { notificationsRefreshTrigger: 0 };

export const slice = createSlice({
	name: "count-data",
	initialState,
	reducers: {
		replace: (_state, { payload }) => ({
			...payload,
			notificationsRefreshTrigger: _state.notificationsRefreshTrigger,
		}),
		delete: () => initialState,
		triggerNotificationsRefresh: (state) => {
			state.notificationsRefreshTrigger = Date.now();
		},
	},
});

export const countDataSelector = (state) => state?.countData || {};
export const notificationsRefreshTriggerSelector = (state) => state?.countData?.notificationsRefreshTrigger || 0;

export const { actions, reducer } = slice;

export default reducer;
